import React from "react";
import AdminLocationsHome from "@/components/admin/AdminLocationsHome";

export default function AdminLocationsScreen() {
  return <AdminLocationsHome />;
}